module.exports = __webpack_public_path__ + "img/404.e49ca3fa.svg";